import React from 'react'
import moment from 'moment'
import Linkify from 'linkify-react'
import { Message } from './types'

interface MessageCardProps {
  message: Message
  showTimestamp: boolean
  getStatusIcon: (message: Message) => JSX.Element | string
  formatTimestamp: (timestamp: string) => string
  backgroundColor: string
  isGroupChat?: boolean
  isFirstInGroup?: boolean
}

const MessageCard: React.FC<MessageCardProps> = ({
  message,
  showTimestamp,
  getStatusIcon,
  formatTimestamp,
  backgroundColor,
  isGroupChat = false,
  isFirstInGroup = false,
}) => {
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    const target = e.target as HTMLAnchorElement
    const url = target.href
    window.open(url, '_blank', 'noopener,noreferrer')
  }
  return (
    <div>
      {showTimestamp && (
        <div className="text-center mb-3">
          <small className="text-white px-2 py-1 rounded">
            {formatTimestamp(message.sent_at)}
          </small>
        </div>
      )}

      {/* Sender name for group messages */}
      {isGroupChat && isFirstInGroup && !message.is_from_me && (
        <div
          className={`mb-1 d-flex ${
            !message.is_from_me
              ? 'justify-content-start'
              : 'justify-content-end'
          }`}
        >
          <div
            style={{
              maxWidth: '60%',
              fontSize: 'clamp(11px, 2.5vw, 13px)',
              color: 'rgba(255, 255, 255, 0.7)',
              marginBottom: '2px',
              fontWeight: '500',
              paddingLeft: '12px',
            }}
          >
            {message.sender?.display_name ||
              message.sender?.identifier ||
              'Unknown'}
          </div>
        </div>
      )}

      <div
        className={`mb-1 d-flex ${
          !message.is_from_me ? 'justify-content-start' : 'justify-content-end'
        }`}
      >
        <div
          className="px-3 py-2"
          style={{
            maxWidth: '60%',
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap',
            borderRadius: message.is_from_me
              ? '24px 24px 0px 24px'
              : '24px 24px 24px 0px',
            lineHeight: '1.4',
            backgroundColor: backgroundColor,
            color: !message.is_from_me ? '#000f30' : '#ffffff',
            textAlign: 'left',
          }}
        >
          <div
            style={{
              wordWrap: 'break-word',
              overflowWrap: 'anywhere',
              whiteSpace: 'pre-wrap',
            }}
          >
            <Linkify
              options={{
                attributes: {
                  onClick: handleLinkClick,
                  style: {
                    color: !message.is_from_me ? '#00bc8c' : '#ffffff',
                    textDecoration: 'underline',
                  },
                },
              }}
            >
              {message.text}
            </Linkify>
          </div>
        </div>
      </div>
      <div
        className={`d-flex ${
          !message.is_from_me ? 'justify-content-start' : 'justify-content-end'
        }`}
      >
        <div
          className="mt-1 mb-4"
          style={{
            fontSize: '10px',
            opacity: 1,
            maxWidth: '70%',
          }}
        >
          {message.is_from_me ? (
            <span
              style={{
                color: (() => {
                  const status = getStatusIcon(message)
                  return status === 'Not Delivered' || status === 'Paused'
                    ? '#ff3e2f'
                    : '#ffffff'
                })(),
              }}
            >
              <span style={{ fontWeight: 'bold' }}>
                {getStatusIcon(message)}
              </span>
              {' at '}
              {moment(message.sent_at).format('MMMM D, YYYY h:mm A')}
            </span>
          ) : (
            <span>
              {message.service} •{' '}
              {moment(message.sent_at).format('MMMM D, YYYY h:mm A')}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default MessageCard
